module.exports = __webpack_public_path__ + "static/img/code.2573869.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ts-img/code.png
// module id = WrR4
// module chunks = 1